import React from 'react';
import { useTranslation } from 'react-i18next';
import { HiXMark } from 'react-icons/hi2';
import CoachOptions from '../WorkoutDebrief/CoachOptions';

/** Modal wrapper around CoachOptions (missed session, event replan…). */
export default function CoachOptionsModal({
  isOpen,
  onClose,
  title,
  subtitle = null,
  analysis,
  decision = null,
  planId,
  source,
  sourceId,
  canEdit,
  onApplied,
  plan = null,
  loading = false,
  loadingText = null,
  children = null
}) {
  const { t } = useTranslation();
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-gray-900/60 backdrop-blur-sm flex items-end md:items-center justify-center p-0 md:p-4 z-50 animate-fade-in">
      <div className="bg-gray-50 w-full md:max-w-4xl rounded-t-3xl md:rounded-3xl shadow-2xl overflow-hidden max-h-[92vh] md:max-h-[90vh] flex flex-col border border-gray-100 animate-slide-in-bottom md:animate-none">
        <div className="p-5 md:p-6 border-b border-gray-100 flex justify-between items-start gap-4 bg-white">
          <div className="min-w-0">
            <h3 className="text-xl md:text-2xl font-black text-gray-900 tracking-tight leading-tight">{title}</h3>
            {subtitle ? <div className="text-xs font-bold text-gray-400 mt-1">{subtitle}</div> : null}
          </div>
          <button
            type="button"
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 p-2 rounded-full hover:bg-gray-100 transition-colors shrink-0"
            aria-label={t('workout.close')}
          >
            <HiXMark className="w-6 h-6" />
          </button>
        </div>

        <div className="p-5 md:p-6 overflow-y-auto pb-10">
          {children}
          {loading ? (
            <div className="py-12 flex flex-col items-center text-center">
              <div className="animate-spin rounded-full h-10 w-10 border-4 border-indigo-100 border-t-indigo-600 mb-4" />
              <div className="text-base font-black text-gray-900">{loadingText || t('coach_options.loading')}</div>
              <div className="text-sm text-gray-500 mt-1">{t('coach_options.loading_hint')}</div>
            </div>
          ) : analysis ? (
            <CoachOptions
              key={`${sourceId}-${analysis?.generated_at || ''}`}
              analysis={analysis}
              decision={decision}
              planId={planId}
              source={source}
              sourceId={sourceId}
              canEdit={canEdit}
              onApplied={onApplied}
              plan={plan}
            />
          ) : (
            <div className="py-10 text-center text-sm text-gray-500">{t('coach_options.no_proposal')}</div>
          )}
        </div>
      </div>
    </div>
  );
}
